export default "__VITE_ASSET__Bp57wtVk__"